"use strict";

exports.__esModule = true;
exports.getPreviewItem = void 0;

var _color = _interopRequireDefault(require("color"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const getPreviewItem = item => {
  const index = item.index,
        referenceId = item.referenceId,
        reference = item.reference,
        mediaId = item.mediaId,
        media = item.media,
        grid = item.grid,
        localeId = item.localeId,
        backgroundColor = item.backgroundColor,
        color = item.color; //    const primaryColor = Color(backgroundColor)
  //    const contrastColor = primaryColor.isLight() && "black" || "white"

  const imageUrl = media && media.imageUrl || referenceId && reference && reference.imageUrl;
  const runningHead = item.runningHead && item.runningHead[localeId];
  const title = item.title && item.title[localeId] || referenceId && reference && reference.title || "Untitled";
  const description = item.description && item.description[localeId];
  let itemType;

  if (referenceId) {
    itemType = "link";
  } else if (mediaId) {
    itemType = "media";
  } // grid


  const m = grid && grid.split(':');
  const cols = m && m[0] || 1;
  const rows = m && m[1] || 1; // id

  const id = "root_content_body_links_" + index; // colors

  return _extends({}, item, {
    id: id,
    itemType: itemType,
    imageUrl: imageUrl,
    runningHead: runningHead,
    title: title,
    description: description,
    cols: cols,
    rows: rows
  });
};

exports.getPreviewItem = getPreviewItem;